import './styles.css'

function About() {
    return (
        <div className="container">
            <div className="about-title" >Quem somos</div>
            <div className="about-sub-title">Nossa missão no Filmes ScoreXP é
                unir fãs de todo o mundo, criando uma<br /> comunidade de abertura
                e entusiasmo. Somos um recurso valioso para os fãs,
                com <br />indicações de filmes mais top. Nunca descansamos sobre
                os louros e estamos sempre procurando <br />melhorar e expandir nossa
                comunidade.
            </div>
        </div>
    )
}

export default About;